var map = {
	"./2009-08-15_Tiffany_lego.JPG": 410386,
	"./2009-09-17_Tiffany_line_art.jpg": 143575,
	"./2009-09-17_Tiffany_shape_art.jpg": 786382,
	"./2010-9-29_Princess_Tiffany_on_her_birthday_drawn_by_Tiffany.jpg": 950560,
	"./2011_-_Tiffany_art_01.jpg": 529514,
	"./2011_-_Tiffany_art_02.jpg": 680501,
	"./2015-01-04_Fat_Mario.jpg": 285620,
	"./2015-01-04_Three_girls.jpg": 326032,
	"./2015-01-04_chocolate_lab.jpg": 184270,
	"./2015-01-04_cupcake.jpg": 530988,
	"./2015-01-04_girl.jpg": 159300,
	"./2015-01-04_mouse.jpg": 224721,
	"./2015-01-04_purple_cow.jpg": 638820,
	"./2015-01-04_ruby_rubarb.jpg": 226955,
	"./2015-01-04_strawberry_cupcake.jpg": 217608
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 481761;